module.exports = __webpack_public_path__ + "img/Desk Stationeryd06.043d30b5.jpg";